// The language switch's page half (unify-ui ship 3, piece f, ruling R21). The nav's hrefs are
// built into every page (the same page at each language's own address — correct with JavaScript
// off; scripts/seo.mjs renderLangSwitch wrote them). A tool's main.js passes each through its OWN
// shareUrl so the design travels to the other language, and says whether something on the page
// does not travel — the note in the open menu tells the visitor BEFORE they leave, not after.
// The hrefs and the note are recomputed when the menu OPENS — never at wiring time (a tool wires
// this wherever its module starts, and its doc may not exist yet): what the open menu says is
// always what the page holds then, and no tool has to call anything on its own edits. Until it
// opens, the baked hrefs stand (the right addresses, no design fragment).
// PURE page-side DOM: no app import, nothing from core.
//
// Picking a language stores the choice (spec "Picking a language … stores the choice"): under the offer line's own key
// (OFFER_KEY, no suffix) the picked language's id — the one stored thing of ship 3's family; an English page shows no
// offer line once a choice is stored (offer.js). The hub, which has no script of its own, wires this through offer-entry.
import { LANGUAGES } from './locales.js';
import { OFFER_KEY } from './offer.js';
export function rememberPick(win) {
  const nav = win.document.querySelector('nav.ui-lang');
  if (!nav) return;
  for (const a of nav.querySelectorAll('ul a[hreflang]')) {
    const L = LANGUAGES.find((l) => l.lang === a.getAttribute('hreflang'));
    if (!L) continue;
    a.addEventListener('click', () => { try { win.localStorage.setItem(OFFER_KEY, L.id); } catch { /* private mode: not kept */ } });
  }
}
export function wireLangSwitch(win, { linkFor, loses }) {
  const nav = win.document.querySelector('nav.ui-lang');
  if (!nav) return () => {};
  rememberPick(win);
  const note = nav.querySelector('.ui-lang-note');
  const details = nav.querySelector('details');
  const refresh = () => {
    for (const a of nav.querySelectorAll('ul a[href]')) {
      // the baked href is site-absolute ('/th/name-tag/'); a shareUrl takes a whole URL — resolve it
      // against THIS page, which is the same address
      a.setAttribute('href', linkFor(new URL(a.getAttribute('href'), win.location.href).toString()));
    }
    if (note) note.hidden = !loses();
  };
  details?.addEventListener('toggle', refresh);   // fires on open and on close — cheap either way
  return refresh;
}
